module.exports = __webpack_public_path__ + "img/logo_no_r.927f0db4.svg";